<div class="form-group" [id]="'fg' + id">
    <label [for]="id">{{title}} {{control | controlRequiredText}}
    </label>

    <i *ngIf="tooltip" class="mgn-left-6 pj-ico pj-ico-ayuda-info text-primary" data-toggle="popover"
        data-placement="top" [attr.data-trigger]="'hover'" data-html="true" [attr.data-content]="tooltip"
        tabindex="0"></i>

    <input-select-search [id]="id" [dataSelect]="dataSelect" [options]="options" [placeholder]="placeholder"
        [control]="control" [dropdownParent]="dropdownParent || ('fg' + id)"></input-select-search>

    <small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}
        <a class="btn-link" *ngIf="messageFooterAction" (click)="onClickActionFooter($event)"  role="button" [title]="messageFooterAction">{{messageFooterAction}}</a>
    </small>

    <div-validation-message [control]="control" [messageRequired]="messageRequired"></div-validation-message>

</div>